// #region imports

// --- Angular
import {
  Component,
} from '@angular/core';

// #endregion

@Component({
  selector: 'hs-respondents-widget-group-v2',
  templateUrl: './respondents-widget-group-v2.component.html',
  styleUrls: ['./respondents-widget-group-v2.component.scss']
})
export class RespondentsWidgetGroupV2Component {

}
